import React, { useState, createContext, useEffect, useMemo } from 'react';

import Editor from './components/Editor';
import ImageToSvg from './components/ImageToSvg';

export const AppContext = createContext({
    svgString: undefined,
    setSvgString: () => { },
});

const SvgEditor = ({ children }) => {
    const [svgString, setSvgString] = useState();
    const value = useMemo(
        () => ({ svgString, setSvgString }),
        [svgString]
    );
    // useeffect to set the svgString to the global state
    useEffect(() => {
        console.log("the string is:", svgString);
    }, [svgString])




    return (
        <AppContext.Provider value={value}>
            {svgString === undefined &&
                <ImageToSvg />
            }
            {svgString !== undefined &&
                <Editor />
            }
        </AppContext.Provider>
    );
};
export default SvgEditor;